<template>
  <b-card class="mb-2">
    <h5 class="mb-2">{{ titulo }}</h5>

    <!-- Buscador remoto (si se pasa prop buscar y no estamos en modo-manual) -->
    <div v-if="buscar && !modoManual" class="mb-2">
      <b-input-group>
        <b-form-input v-model.trim="q" placeholder="Buscar por código / nombre" @input="debouncedFetch"/>
        <b-input-group-append>
          <b-button @click="fetch" variant="primary">Buscar</b-button>
        </b-input-group-append>
      </b-input-group>
      <b-list-group v-if="resultados.length" class="mt-2">
        <b-list-group-item
          v-for="(r,idx) in resultados"
          :key="idx"
          class="d-flex align-items-center justify-content-between"
        >
          <div>
            <div class="font-weight-bold">({{ r.codigo }}) {{ r.descripcion }}</div>
          </div>
          <div class="d-flex align-items-center">
            <b-form-input v-model.number="r.cantidad" type="number" min="1" class="mr-2" style="width:90px" />
            <b-button size="sm" variant="success" @click="agregar(r)">Agregar</b-button>
          </div>
        </b-list-group-item>
      </b-list-group>
      <div v-else class="text-muted mt-2">Sin resultados…</div>
    </div>

    <!-- Modo manual (laboratorio/atención/terapias por ahora) -->
    <div v-else class="mb-2">
      <b-form @submit.prevent="agregarManual">
        <b-row>
          <b-col md="4">
            <b-form-group label="Código">
              <b-form-input v-model.trim="manual.codigo" required />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group label="Descripción">
              <b-form-input v-model.trim="manual.descripcion" required />
            </b-form-group>
          </b-col>
          <b-col md="2">
            <b-form-group label="Cant.">
              <b-form-input type="number" min="1" v-model.number="manual.cantidad" />
            </b-form-group>
          </b-col>
        </b-row>
        <b-form-group label="Notas (opcional)">
          <b-form-input v-model.trim="manual.notas" />
        </b-form-group>
        <b-button type="submit" variant="success">Agregar</b-button>
      </b-form>
    </div>

    <!-- Lista de seleccionados -->
    <b-table
      small
      striped
      hover
      class="mt-3"
      :items="itemsMapped"
      :fields="['codigo','descripcion','cantidad','notas','acciones']"
      head-variant="light"
    >
      <template #cell(acciones)="ctx">
        <b-button size="sm" variant="danger" @click="$emit('eliminar', ctx.index)">Quitar</b-button>
      </template>
    </b-table>
  </b-card>
</template>

<script>
import { BCard, BInputGroup, BInputGroupAppend, BFormInput, BButton, BListGroup, BListGroupItem, BForm, BRow, BCol, BFormGroup, BTable } from "bootstrap-vue";

export default {
  name: "ServiceSelector",
  components: { BCard, BInputGroup, BInputGroupAppend, BFormInput, BButton, BListGroup, BListGroupItem, BForm, BRow, BCol, BFormGroup, BTable },
  props: {
    titulo: { type: String, required: true },
    categoria: { type: String, required: true }, // 'laboratorio' | 'imagenes' | 'procedimientos' | 'atencion_medica' | 'terapias'
    buscar: { type: Function, default: null },   // función async (q) => [{id,codigo,descripcion}]
    items: { type: Array, default: () => [] },   // array reactivo desde el padre
    modoManual: { type: Boolean, default: false }
  },
  data() {
    return {
      q: "",
      resultados: [],
      debouncer: null,
      manual: { codigo: "", descripcion: "", cantidad: 1, notas: "" },
    };
  },
  computed: {
    itemsMapped() {
      return (this.items || []).map(i => ({
        codigo: i.codigo,
        descripcion: i.descripcion,
        cantidad: i.cantidad || 1,
        notas: i.notas || "",
      }));
    }
  },
  methods: {
    debouncedFetch() {
      clearTimeout(this.debouncer);
      this.debouncer = setTimeout(this.fetch, 350);
    },
    async fetch() {
      if (!this.buscar) return;
      this.resultados = (await this.buscar(this.q))?.map(r => ({ ...r, cantidad: 1 })) || [];
    },
    agregar(r) {
      const item = {
        origen: 'catalogo',
        id: r.id ?? null,
        codigo: r.codigo,
        descripcion: r.descripcion,
        cantidad: r.cantidad || 1,
        notas: r.notas || "",
      };
      this.$emit("agregar", item);
    },
    agregarManual() {
      const { codigo, descripcion, cantidad, notas } = this.manual;
      if (!codigo || !descripcion) return;
      this.$emit("agregar", {
        origen: 'manual',
        id: null,
        codigo, descripcion,
        cantidad: cantidad || 1,
        notas: notas || ""
      });
      this.manual = { codigo: "", descripcion: "", cantidad: 1, notas: "" };
    },
  },
};
</script>
